import getDataByKey from "@/firebase/firestore/getDataByKey"
import getByLikes from "./getByLikes"
export async function getUserData(id,getMeshes,getLikes){
    const profile = await getDataByKey({collectionName:"users",key:'handle',value:id})

    const sendProfile = (profile.length === 0) ? {handle:false} : profile[0]
    const value = sendProfile?.id || id
    const madeBy = getMeshes ? await getDataByKey({collectionName:"mesh",key:'uid',value}) : []
    const likes = getLikes ? await getByLikes(value) : []
    return {profile:sendProfile,madeBy,likes}
}